import { Eye, EyeOff } from "lucide-react";
import type * as React from "react";
import { useState, type JSX } from "react";

import { cn } from "../../lib/cn.js";
import { Input } from "../ui/input.js";

/** Password field with a show/hide toggle (matches the fynd-erp auth design). */
export function PasswordInput({
  className,
  ...props
}: React.ComponentProps<"input">): JSX.Element {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={cn("pr-10", className)} />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-0 top-0 flex h-9 w-10 items-center justify-center text-muted-foreground transition-colors hover:text-foreground"
      >
        {show ? (
          <EyeOff className="h-4 w-4" aria-hidden />
        ) : (
          <Eye className="h-4 w-4" aria-hidden />
        )}
      </button>
    </div>
  );
}
